import { paymentList } from "constants/payment";


const initialState = {
  paymentList: {},
};

const payment = (state = initialState, action) => {
  switch (action.type) {
    case paymentList:
      return { ...state, paymentList: action.payload };

    default:
      return state;
  }
};

export default payment;
